/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Layout,
  Card,
  Heading,
  DisplayText,
  Icon,
  Button,
  TextStyle,
  ProgressBar,
  Tooltip
} from '@shopify/polaris';
import {
  CircleTickMajor,
  CaretDownMinor,
  CaretUpMinor,
  FilterMajor,
  SearchMinor,
  ProductsMajor,
  QuestionMarkMajor
} from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import history from 'src/routes/history';
import { CSSTransition } from 'react-transition-group';
import { startSABLoading, stopSABLoading } from 'src/integrations/shopify-app-bridge/loading';
import Congrat from 'src/assets/images/dashboard/congrat.png';
import { CHECKLIST4 } from 'src/constants/onboarding';
import YoutubeModal from 'src/components/views/common/youtube-modal';
import * as checklistActions from 'actions/dashboard/checklist-actions';
import * as dashboardAction from 'actions/dashboard-actions';

type Props = {
  name: string
};

type ComposedProps = Props & WithI18nProps;

type State = {
  active: boolean,
  hidden: boolean,
  selectChecklistId: string,
  youtubeModal: Object
};

class OnboardingChecklist extends Component<ComposedProps, State> {
  state = {
    active: false,
    hidden: false,
    selectChecklistId: '',
    youtubeModal: null
  };

  componentDidMount() {
    const { getChecklist, expanded = true } = this.props;

    // Get list of notification
    getChecklist();

    this.setState({ active: expanded });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loading === false && nextProps.loading === true) {
      startSABLoading();
    }

    if (this.props.loading === true && nextProps.loading === false) {
      stopSABLoading();
    }
  }

  // Handle render checlist 3 modal
  renderChecklist3ModalOptions = () => {
    const { selectChecklistId } = this.state;
    const { selectChecklistLoading, i18n } = this.props;

    const checkList3Options = [
      {
        id: 'checklistFilter',
        icon: FilterMajor,
        name: i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.option1_Name'),
        description: i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.option1_Description')
      },
      {
        id: 'checklistSearch',
        icon: SearchMinor,
        name: i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.option2_Name'),
        description: i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.option2_Description')
      },
      {
        id: 'checklistPromotion',
        icon: ProductsMajor,
        name: i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.option3_Name'),
        description: i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.option3_Description')
      }
    ];

    return (
      <Modal title="" titleHidden large open={true}>
        <Modal.Section>
          <div className="align-center modal-title">
            <DisplayText size="small">
              {i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.displayText')}
            </DisplayText>
            <TextStyle>
              {i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.textStyle')}
            </TextStyle>
          </div>
        </Modal.Section>
        <Modal.Section>
          <div className="BC-PreOnboardingChecklist">
            <Layout>
              {checkList3Options.map((item, index) => (
                <Layout.Section oneThird key={index}>
                  <div className="item-checklist align-center">
                    {/* Icon */}
                    <span className="icon">
                      <Icon source={item.icon} color="primary" />
                    </span>
                    {/* Name */}
                    <div className="name">{item.name}</div>
                    {/* Description */}
                    <div className="description">{item.description}</div>
                    {/* Action */}
                    <div
                      className={
                        selectChecklistLoading && selectChecklistId === item.id ? 'active' : ''
                      }>
                      <Button onClick={() => this.selectChecklist(item.id)}>
                        {i18n.translate('AdminHTML.Common.Action.select')}
                      </Button>
                    </div>
                  </div>
                </Layout.Section>
              ))}
            </Layout>
          </div>
        </Modal.Section>
      </Modal>
    );
  };

  // Render action in checklist
  renderChecklistAction = (name, style, action, actionIndex, currentStep) => {
    const { i18n } = this.props;

    switch (style) {
      case 1: {
        // not update I18n yet (currently, we don't use this style)
        const { step, description, linkText = '', completed: itemCompleted } = action;
        return (
          <div
            className={`checklist-item checklist-item-style_01 ${
              currentStep === actionIndex ? 'current' : ''
            }`}
            key={'action-' + actionIndex}>
            {itemCompleted ? (
              <div className="item-description completed">
                <span className="completed-icon">
                  <Icon color="success" source={CircleTickMajor} />
                </span>
                <p>{description}</p>
              </div>
            ) : (
              <div className="item-description un-completed">
                <span className="un-completed-icon">{step}</span>
                <p>{description}</p>
              </div>
            )}

            <div className="item-action">
              <Button primary size="slim" onClick={() => this.featureAction(action)}>
                {linkText}
              </Button>
            </div>
          </div>
        );
      }
      case 2: {
        // not update I18n yet (currently, we don't use this style)
        const { description, title = '', completed: itemCompleted } = action;
        return (
          <div className="checklist-item checklist-item-style_02" key={'action-' + actionIndex}>
            {itemCompleted ? (
              <div className="item-description completed">
                <span className="completed-icon">
                  <Icon source={CircleTickMajor} color="success" />
                </span>
                <p>
                  <TextStyle variation="strong">{title}</TextStyle>: {description}
                </p>
              </div>
            ) : (
              <div className="item-description un-completed">
                <span className="un-completed-icon"></span>
                <p>
                  <TextStyle variation="strong">{title}</TextStyle>: {description}
                </p>
              </div>
            )}
          </div>
        );
      }

      case 3: {
        const { step, completed: itemCompleted } = action;
        return (
          <div
            className={`checklist-item checklist-item-style_03 ${
              currentStep === actionIndex ? 'current' : ''
            }`}
            key={'action-' + actionIndex}>
            {itemCompleted ? (
              <div className="item-description completed">
                <span className="completed-icon">
                  <Icon source={CircleTickMajor} color="success" />
                </span>
                <p>
                  <TextStyle>
                    {i18n.translate(`AdminHTML.Checklist.Checklist3.${name}_Step${step}_Title`)}
                  </TextStyle>
                  <span className="tooltip">
                    <Tooltip
                      content={
                        <span className="tooltipContent">
                          {i18n.translate(
                            `AdminHTML.Checklist.Checklist3.${name}_Step${step}_Description`
                          )}
                        </span>
                      }
                      preferredPosition="above">
                      <Icon source={QuestionMarkMajor} color="base" />
                    </Tooltip>
                  </span>
                </p>
              </div>
            ) : (
              <div className="item-description un-completed">
                <span className="un-completed-icon">{step}</span>
                <p>
                  <TextStyle variation="strong">
                    {i18n.translate(`AdminHTML.Checklist.Checklist3.${name}_Step${step}_Title`)}
                  </TextStyle>
                  <span className="tooltip">
                    <Tooltip
                      content={
                        <span className="tooltipContent">
                          {' '}
                          {i18n.translate(
                            `AdminHTML.Checklist.Checklist3.${name}_Step${step}_Description`
                          )}
                        </span>
                      }
                      preferredPosition="above">
                      <Icon source={QuestionMarkMajor} color="base" />
                    </Tooltip>
                  </span>
                </p>
              </div>
            )}
          </div>
        );
      }
      case 4: {
        // this style is being used
        const { step } = action;
        const current = currentStep === actionIndex;
        const checklistItem = CHECKLIST4[actionIndex];
        return (
          <div
            className={`checklist-item checklist-item-style_04 ${current ? 'current' : ''}`}
            key={'action-' + actionIndex}>
            <div className="item-description">
              <span className="step-icon">{step}</span>
              <div>
                <p className="step-title">
                  <TextStyle variation="strong">{i18n.translate(checklistItem.title)}</TextStyle>
                </p>
                {current && (
                  <React.Fragment>
                    <p style={{ marginTop: '8px' }}>
                      <TextStyle>{i18n.translate(checklistItem.description)}</TextStyle>
                    </p>
                    <div style={{ marginTop: '8px' }}>
                      <Button
                        primary
                        onClick={() => {
                          history.push(checklistItem.action);
                        }}>
                        <TextStyle>{i18n.translate(checklistItem.button)}</TextStyle>
                      </Button>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>

            {current && (
              <div className="BC-Checklist-Video__Wrapper">
                <div className="BC-Checklist-Video__Container">
                  <img
                    data-url={checklistItem.video}
                    data-title={i18n.translate(checklistItem.title)}
                    src={checklistItem.thumbnail}
                    alt={i18n.translate(checklistItem.title)}
                    onClick={this.openVideo}
                  />
                </div>
              </div>
            )}
          </div>
        );
      }
      default:
        return '';
    }
  };
  render() {
    const {
      name = '',
      total = 0,
      style = 4,
      completed = 0,
      actions,
      skipActionLoading,
      hideSkipButton = false,
      i18n,
      subscriptionV3
    } = this.props;

    if (subscriptionV3) return '';

    const { active, hidden, youtubeModal } = this.state;

    // Calculate percent step
    const stepPercent3Step = [0, 25, 50, 100];
    const stepPercent4Step = [0, 25, 50, 75, 100];
    const completedPercent =
      total !== 0 ? (total === 3 ? stepPercent3Step[completed] : stepPercent4Step[completed]) : 0;

    const currentStep = _.findIndex(actions, item => item.completed === false);

    // Do not render anything if name is empty
    if (_.isEmpty(name)) {
      return '';
    }

    // show banner (for OBD3) before go to checklist
    if (name === 'checklist3') {
      return this.renderChecklist3ModalOptions();
    }
    const steps = {
      style_1: 4,
      style_2: 4,
      style_3: 3,
      style_4: 3
    };
    return (
      total > 0 &&
      !hidden && (
        <div className={`BC-OnboardingChecklist ${active ? ' active' : ''}`}>
          <Card>
            <Card.Header
              title={
                <div className="BC_Card-Header">
                  <Heading>
                    {i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.cardHeading')}{' '}
                    <img className="icon" src={Congrat} alt="" />
                  </Heading>
                  <div className="progress-bar">
                    <TextStyle variation="strong">{completedPercent} %</TextStyle>
                    <div className="progress">
                      <ProgressBar progress={completedPercent} size="small" />
                    </div>
                  </div>
                </div>
              }>
              <div className="BC-Block-Dismiss--Right-Menu">
                <Button
                  icon={active ? CaretDownMinor : CaretUpMinor}
                  plain
                  onClick={this.toggleContent}
                />
              </div>
            </Card.Header>
            <CSSTransition
              in={active}
              timeout={500}
              classNames="item-transition transition"
              unmountOnExit>
              <Card.Section>
                <div className="checklist-content">
                  <Layout>
                    <Layout.Section oneThird>
                      <div className="checklist">
                        {actions &&
                          actions.map((action, actionIndex) =>
                            this.renderChecklistAction(
                              name,
                              style,
                              action,
                              actionIndex,
                              currentStep
                            )
                          )}
                        {style === 4 && completed === total && (
                          <div style={{ margin: '1.25rem 2.5rem 0' }}>
                            <Button primary onClick={this.skipAction} loading={skipActionLoading}>
                              <TextStyle variation="strong">
                                {i18n.translate('AdminHTML.Dashboard.Common.whatSNext')}
                              </TextStyle>
                            </Button>
                          </div>
                        )}
                      </div>
                    </Layout.Section>
                    {style === 4 && (
                      <Layout.Section>
                        {completed !== total && (
                          <div className="BC-Checklist-Video__Wrapper">
                            <div className="BC-Checklist-Video__Container">
                              <img
                                data-url={CHECKLIST4[currentStep].video}
                                data-title={i18n.translate(CHECKLIST4[currentStep].title)}
                                src={CHECKLIST4[currentStep].thumbnail}
                                alt={i18n.translate(CHECKLIST4[currentStep].title)}
                                onClick={this.openVideo}
                              />
                            </div>
                          </div>
                        )}
                      </Layout.Section>
                    )}
                  </Layout>
                </div>
                {!hideSkipButton && (
                  <div className="action-checklist">
                    {completed === steps[`style_${style}`] && style !== 4 ? (
                      <Button primary onClick={this.skipAction} loading={skipActionLoading}>
                        <TextStyle variation="strong">
                          {i18n.translate('AdminHTML.Dashboard.Common.whatSNext')}
                        </TextStyle>
                      </Button>
                    ) : (
                      <div className="action-skip">
                        <Button plain onClick={this.skipAction} loading={skipActionLoading}>
                          {i18n.translate('AdminHTML.Dashboard.OnboardingChecklist.buttonChildren')}
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </Card.Section>
            </CSSTransition>
          </Card>
          <YoutubeModal
            active={youtubeModal !== null}
            {...youtubeModal}
            onClose={this.handleCloseYoutubeModal}
          />
        </div>
      )
    );
  }

  toggleContent = () => {
    this.setState(({ active }) => ({
      active: !active
    }));
  };

  skipAction = async () => {
    const { skipAction, updateDashboardBlock } = this.props;

    const result = await skipAction();
    if (result.type === 'SKIP_ACTION_ON_CHECKLIST_SUCCESS') {
      const { blocks } = result.payload;
      this.setState({ hidden: true });
      updateDashboardBlock(blocks);
    }
  };

  // tracking event for OBD 1
  featureAction = (action: Object) => {
    const { eventSource, eventName, linkPath } = action;
    const { trackEvent } = this.props;

    // Call to tracking event
    trackEvent(eventSource, eventName, 'onboarding');
    history.push(linkPath);
  };

  selectChecklist = id => {
    const { selectChecklist } = this.props;

    this.setState({ selectChecklistId: id });

    selectChecklist(id);
  };

  openVideo = e => {
    const { url, title } = e.currentTarget.dataset;
    // Open video modal
    this.setState({
      youtubeModal: { embeddedURL: url, title }
    });
  };

  handleCloseYoutubeModal = () => this.setState({ youtubeModal: null });
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  return {
    loading: _.get(state.checklist, 'loading', false),
    success: _.get(state.checklist, 'success', false),
    selectChecklistLoading: _.get(state.checklist, 'selectChecklistLoading', false),
    skipActionLoading: _.get(state.checklist, 'skipActionLoading', false),
    total: _.get(state.checklist, 'total', 0),
    name: _.get(state.checklist, 'name', ''),
    style: _.get(state.checklist, 'style', 1),
    completed: _.get(state.checklist, 'completed', 0),
    actions: _.get(state.checklist, 'actions', []),
    subscriptionV3: _.get(tenantApp, 'settings.subscriptionV3.settings.enable', true)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getChecklist: () => dispatch(checklistActions.getChecklist(ownProps.i18n)),
  selectChecklist: id => dispatch(checklistActions.selectChecklist(id, ownProps.i18n)),
  skipAction: () => dispatch(checklistActions.skipAction(ownProps.i18n)),
  trackEvent: (eventSource, eventName, label) =>
    dispatch(checklistActions.trackEvent(eventSource, eventName, label)),
  updateDashboardBlock: (blocks: Object) => dispatch(dashboardAction.updateDashboardBlock(blocks))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(OnboardingChecklist));
